<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <span @click="rootDir = null">Topics</span>
      </div>
    </div>
    <div class="card-content">
      <software-topics :topics="topics" @select="selectTopic"></software-topics>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import SoftwareTopics from './components/SoftwareTopicsComponent.vue';

export default {
  components: { SoftwareTopics },
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const topics = [
      'iDirect MODEMS',
      'u8 SOFTWARE',
      'ACCESS APP'
    ];
    
    const selectTopic = (topic) => {
      // navigate user to topic
      root.$router.push({ 
        name: 'softwareTopic', 
        query: { rootDir: `/software-downloads/${topic}` }
      });
    }

    return {
      topics,
      selectTopic
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
